var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.483 58.6209C48.7149 63.4491 41.2854 66.3624 33.1851 66.3624C14.8668 66.3624 0 51.4956 0 33.1812C0 14.8668 14.8668 0 33.1851 0C51.4956 0 66.3663 14.8668 66.3663 33.1812C66.3663 41.2854 63.453 48.7188 58.6248 54.4791L77.1459 73.0041C77.7153 73.5735 78 74.3223 78 75.075C78 77.3643 75.9057 78 75.075 78C74.3262 78 73.5774 77.7153 73.0041 77.142L54.483 58.6209ZM33.1851 5.8539C18.0999 5.8539 5.8578 18.0999 5.8578 33.1812C5.8578 48.2625 18.0999 60.5085 33.1851 60.5085C48.2625 60.5085 60.5124 48.2625 60.5124 33.1812C60.5124 18.0999 48.2625 5.8539 33.1851 5.8539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMagnify);
export default __webpack_public_path__ + "static/media/ic_magnify.8de79a3291e8b0a7bdd142d075b65466.svg";
export { ForwardRef as ReactComponent };